{
  "AGENT_MGMT": {
    "HEADER": "ഏജന്റുമാർ",
    "HEADER_BTN_TXT": "ഏജന്റിനെ ചേർക്കുക",
    "LOADING": "ഏജന്റ് പട്ടിക ലഭ്യമാക്കുന്നു",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "അഡ്മിനിസ്‌ട്രേറ്റർ",
      "AGENT": "ഏജന്റ്"
    },
    "COUNT": "{n} agent | {n} agents",
    "LIST": {
      "404": "ഈ അക്കൗണ്ടുമായി ബന്ധപ്പെട്ട ഏജന്റുകളൊന്നുമില്ല",
      "TITLE": "നിങ്ങളുടെ ടീമിലെ ഏജന്റുമാരെ മാനേജുചെയ്യുക",
      "DESC": "നിങ്ങൾക്ക് നിങ്ങളുടെ ടീമിലെ ഏജന്റുമാരെ ചേർക്കാനും നീക്കംചെയ്യാനും കഴിയും.",
      "NAME": "പേര്",
      "EMAIL": "ഇമെയിൽ",
      "STATUS": "സ്റ്റാറ്റസ്",
      "ACTIONS": "പ്രവർത്തനങ്ങൾ",
      "VERIFIED": "പരിശോധിച്ചു",
      "VERIFICATION_PENDING": "പരിശോധന തീർപ്പുകൽപ്പിച്ചിട്ടില്ല",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "നിങ്ങളുടെ ടീമിലേക്ക് ഏജന്റിനെ ചേർക്കുക",
      "DESC": "നിങ്ങളുടെ ഇൻ‌ബോക്സുകൾ‌ക്കുള്ള പിന്തുണ കൈകാര്യം ചെയ്യാൻ‌ കഴിയുന്ന ആളുകളെ നിങ്ങൾ‌ക്ക് ചേർ‌ക്കാൻ‌ കഴിയും.",
      "CANCEL_BUTTON_TEXT": "റദ്ദാക്കുക",
      "FORM": {
        "NAME": {
          "LABEL": "ഏജന്റിന്റെ പേര്",
          "PLACEHOLDER": "ദയവായി ഏജന്റിന്റെ പേര് നൽകുക"
        },
        "AGENT_TYPE": {
          "LABEL": "ഏജന്റ് തരം",
          "PLACEHOLDER": "ദയവായി ഒരു തരം തിരഞ്ഞെടുക്കുക",
          "ERROR": "ഏജന്റ് തരം ആവശ്യമാണ്"
        },
        "EMAIL": {
          "LABEL": "ഇമെയിൽ വിലാസം",
          "PLACEHOLDER": "ദയവായി ഏജന്റിന്റെ ഒരു ഇമെയിൽ വിലാസം നൽകുക"
        },
        "SUBMIT": "ഏജന്റിനെ ചേർക്കുക"
      },
      "API": {
        "SUCCESS_MESSAGE": "ഏജന്റിനെ വിജയകരമായി ചേർത്തു",
        "EXIST_MESSAGE": "ഏജന്റ് ഇമെയിൽ ഇതിനകം ഉപയോഗത്തിലാണ്, ദയവായി മറ്റൊരു ഇമെയിൽ വിലാസം പരീക്ഷിക്കുക",
        "ERROR_MESSAGE": "വൂട്ട് സെർവറിലേക്ക് കണക്റ്റുചെയ്യാനായില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "ഇല്ലാതാക്കുക",
      "API": {
        "SUCCESS_MESSAGE": "ഏജന്റിനെ വിജയകരമായി ഇല്ലാതാക്കി",
        "ERROR_MESSAGE": "വൂട്ട് സെർവറിലേക്ക് കണക്റ്റുചെയ്യാനായില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക"
      },
      "CONFIRM": {
        "TITLE": "ഇല്ലാതാക്കൽ സ്ഥിരീകരിക്കുക",
        "MESSAGE": "<p><b>ഏജന്റുമാർ</b></p><p> ഒരു <b>ഏജൻറ്</b> നിങ്ങളുടെ ഉപഭോക്തൃ പിന്തുണാ ടീമിലെ ഒരു അംഗമാണ്. </p><p> ഏജന്റുമാർക്ക് നിങ്ങളുടെ ഉപയോക്താക്കളിൽ നിന്നുള്ള സന്ദേശങ്ങൾ കാണാനും മറുപടി നൽകാനും കഴിയും. നിങ്ങളുടെ അക്കൗണ്ടിലുള്ള എല്ലാ ഏജന്റുമാരെയും ഈ പട്ടിക കാണിക്കുന്നു. </ p> <p> ഒരു പുതിയ ഏജന്റിനെ ചേർക്കുന്നതിന് <b> ഏജന്റിനെ ചേർക്കുക </ b> ബട്ടൺ ക്ലിക്കുചെയ്യുക. നിങ്ങൾ ചേർത്ത ഏജന്റിന് അവരുടെ അക്കൗണ്ട് സജീവമാക്കുന്നതിന് ഒരു സ്ഥിരീകരണ ലിങ്കുള്ള ഇമെയിൽ ലഭിക്കും. അതിനുശേഷം അവർക്ക് ചാറ്റ് വൂട്ട് ആക്സസ് ചെയ്യാനും സന്ദേശങ്ങളോട് പ്രതികരിക്കാനും കഴിയും.</p> <p> ചാറ്റ് വൂട്ടിന്റെ സവിശേഷതകളിലേക്കുള്ള ആക്സസ് ഇനിപ്പറയുന്ന റോളുകളെ അടിസ്ഥാനമാക്കിയുള്ളതാണ്. </p><p> <b>ഏജൻറ്</ b> - ഈ റോൾ‌ ഉള്ള ഏജന്റുമാർ‌ക്ക് ഇൻ‌ബോക്‍സുകൾ‌, റിപ്പോർ‌ട്ടുകൾ‌, സംഭാഷണങ്ങൾ‌ എന്നിവ മാത്രമേ ആക്‌സസ് ചെയ്യാൻ‌ കഴിയൂ. അവർക്ക് മറ്റ് ഏജന്റുമാരുടെയോ അല്ലെങ്കിൽ‌ തങ്ങളുടേയോ സംഭാഷണങ്ങൾ‌ നിർ‌ണ്ണയിക്കാനും സംഭാഷണങ്ങൾ‌ പരിഹരിക്കാനും കഴിയും.</p><p> <b>അഡ്മിനിസ്ട്രേറ്റർ</b> - ഒരു സാധാരണ ഏജന്റിന്റെ പ്രത്യേകാവകാശങ്ങളോടൊപ്പം ക്രമീകരണങ്ങളും ബില്ലിംഗും ഉൾപ്പെടെ നിങ്ങളുടെ അക്കൗണ്ടിൽ ലഭ്യമായ എല്ലാ ചാറ്റ് വൂട്ട് സവിശേഷതകളിലേക്കും ആക്‌സസ് ഉണ്ടായിരിക്കുക. </ p> ",
        "YES": "അതെ, ഇല്ലാതാക്കുക ",
        "NO": "ഇല്ല, സൂക്ഷിക്കുക"
      }
    },
    "EDIT": {
      "TITLE": "ഏജന്റിനെ എഡിറ്റുചെയ്യുക",
      "FORM": {
        "NAME": {
          "LABEL": "ഏജന്റിന്റെ പേര്",
          "PLACEHOLDER": "ദയവായി ഏജന്റിന്റെ പേര് നൽകുക"
        },
        "AGENT_TYPE": {
          "LABEL": "ഏജന്റ് തരം",
          "PLACEHOLDER": "ദയവായി ഒരു തരം തിരഞ്ഞെടുക്കുക",
          "ERROR": "ഏജന്റ് തരം ആവശ്യമാണ്"
        },
        "EMAIL": {
          "LABEL": "ഇമെയിൽ വിലാസം",
          "PLACEHOLDER": "ദയവായി ഏജന്റിന്റെ ഒരു ഇമെയിൽ വിലാസം നൽകുക"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "ലഭ്യത",
          "PLACEHOLDER": "Please select an availability status",
          "ERROR": "Availability is required"
        },
        "SUBMIT": "ഏജന്റിനെ എഡിറ്റുചെയ്യുക"
      },
      "BUTTON_TEXT": "എഡിറ്റുചെയ്യുക",
      "CANCEL_BUTTON_TEXT": "റദ്ദാക്കുക",
      "API": {
        "SUCCESS_MESSAGE": "ഏജന്റിനെ വിജയകരമായി അപ്‌ഡേറ്റുചെയ്‌തു",
        "ERROR_MESSAGE": "വൂട്ട് സെർവറിലേക്ക് കണക്റ്റുചെയ്യാനായില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "പാസ്സ്‌വേർഡ് പുനഃസജ്ജീകരണം",
        "ADMIN_SUCCESS_MESSAGE": "പാസ്‌വേഡ് പുനഃസജ്ജീകരണത്തിന് ഉള്ള ഒരു ഇമെയിൽ ഏജന്റിന് അയച്ചു",
        "SUCCESS_MESSAGE": "ഏജന്റിന്റെ പാസ്‌വേഡ് വിജയകരമായി പുനഃസജീകരിച്ചു",
        "ERROR_MESSAGE": "വൂട്ട് സെർവറിലേക്ക് കണക്റ്റുചെയ്യാനായില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക"
      }
    },
    "SEARCH_PLACEHOLDER": "ഏജന്റുകളെ തിരയുക...",
    "NO_RESULTS": "No agents found matching your search",
    "SEARCH": {
      "NO_RESULTS": "ഒരു ഫലവും കണ്ടെത്താനായില്ല."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "ഒന്നുമില്ല",
      "TITLE": {
        "AGENT": "ഏജന്റിനെ തിരഞ്ഞെടുക്കുക",
        "TEAM": "ടീം തിരഞ്ഞെടുക്കുക"
      },
      "LIST": {
        "NONE": "ഒന്നുമില്ല"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "ഏജന്റകളെ ഒന്നും കണ്ടെത്താൻ സാധിച്ചില്ല",
          "TEAM": "ടീമുകളൊന്നും കണ്ടെത്താനായില്ല"
        },
        "PLACEHOLDER": {
          "AGENT": "ഏജന്റുകളെ തിരയുക",
          "TEAM": "ടീമുകളെ തിരയുക",
          "INPUT": "Search for agents"
        }
      }
    }
  }
}
